// Catch-all 404 route — '/$'.
//
// TanStack Router's file-based convention treats a top-level `$.tsx`
// (no name) as the splat fallback. Any path that doesn't match a more
// specific sibling lands here. We name the path that failed and offer one
// way back: the console for signed-in admins, the public streams otherwise.
import { createFileRoute, Link, useLocation } from '@tanstack/react-router'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { useDocumentTitle } from '@/hooks/use-document-title'
import { useAuthUser } from '@/stores/auth-store'

export const Route = createFileRoute('/$')({
  component: NotFoundPage,
})

function NotFoundPage() {
  useDocumentTitle('Page not found')
  const { pathname } = useLocation()
  const user = useAuthUser()
  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin'

  return (
    <main className="mx-auto w-full max-w-xl px-4 py-12 sm:px-6">
      <Card className="w-full" data-testid="not-found">
        <CardHeader className="space-y-2">
          <h1 className="text-2xl font-semibold leading-tight">Page not found</h1>
          <p className="text-sm text-muted-foreground">
            There is nothing at{' '}
            <code className="break-all font-mono text-[13px] text-foreground">{pathname}</code>.
          </p>
        </CardHeader>
        <CardContent>
          {isAdmin ? (
            <Button asChild>
              <Link to="/admin">Go to the console</Link>
            </Button>
          ) : (
            <Button asChild>
              <Link to="/streams">Go to live streams</Link>
            </Button>
          )}
        </CardContent>
      </Card>
    </main>
  )
}
